const header = require('./sections/header/header');
const footer = require('./sections/footer/footer');
const subscribe = require('./sections/footer/subscribe');
const account = require('./pages/account');
// const search = require('./sections/header/search');
const cartsummary = require('./pages/cart/cartsummary');

header.init();
footer.init();
subscribe.init();
account.init();
// search.init();
cartsummary.init();


// WEBPACK FOOTER //
// ./cartridges/app_boggi_core/cartridge/js/main.js